module.exports = __webpack_public_path__ + "static/img/mo.89eb67f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mo.png
// module id = 4DFe
// module chunks = 1